import React, { useState, useEffect } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  Button,
  Grid,
  Typography,
  Card,
  CardHeader,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Dialog, DialogActions, DialogContent, DialogTitle,
  CardContent,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createBanner,
  deleteBanner,
  getAllBanner,
  updateBanner
} from "../../State/Banner/Action";
import { createSpecialOffer, getOffers, getOffersByBrand, getOffersByVendor, getSpecialOffer } from "../../State/Offer/Action";
import dayjs from "dayjs";
import { deleteOffer } from "../../../Vendor/State/Offer/Action";
import { getVendors } from "../../State/Vendor/Action";
import { getProducts } from "../../State/Product/Action";
import { DataGrid } from "@mui/x-data-grid";
import "../Size/AddSize.css"
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { AddCircle, Delete, Edit, FileDownload, PictureAsPdf, Print, UploadFile } from '@mui/icons-material';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PermissionService } from "../../../config/permissionService";
import { getSelectedExportRows } from "../../../config/exportSelection";
import ImagePopup from "../../../Common/ImagePopup";

const AddBanner = () => {
  const { banners, adminOffers, adminVendor, adminProduct } = useSelector((store) => store);
  const dispatch = useDispatch();
  const [bannerData, setBannerData] = useState({
    vendorId: "",
    brandId: "",
    category: "",
    offerIds: [],
    specialOfferIds: [],
  });
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [vendorId, setVendorId] = useState(null)
  const [openAddOfferModal, setOpenAddOfferModal] = useState(false);
  const [isFestival, setIsFestival] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const fileInputRef = React.useRef(null);
  const [error, setError] = useState("");
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  // Get current date and time in YYYY-MM-DDTHH:mm format
  const todayDateTime = dayjs().format("YYYY-MM-DDTHH:mm");

  const [offerData, setOfferData] = useState({
    discountPercentage: "",
    startDate: "", // Default Start Date
    endDate: "", // Default End Date
  });



  useEffect(() => {
    dispatch(getAllBanner());
    dispatch(getVendors())
    dispatch(getProducts())
  }, [dispatch]);

  useEffect(() => {
    if (selectedBrandId && selectedBrandId !== 0) {
      // Brand is priority if selected
      dispatch(getOffersByBrand(selectedBrandId));
    } else if (vendorId && vendorId !== 0) {
      dispatch(getOffersByVendor(vendorId));
    } else if (isFestival) {
      dispatch(getSpecialOffer())
    } else {
      dispatch(getOffers());
    }
  }, [dispatch, isFestival, selectedBrandId, vendorId]);


  const fieldChanged = (event) => {
    setSelectedBrandId(event.target.value);
    setBannerData((prevState) => ({
      ...prevState,
      brandId: event.target.value
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBannerData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(selectedFile.type)) {
      setError("Only JPG, JPEG, and PNG images are allowed!");
      setSelectedImageFile(null);
      setImagePreview(null);
      return;
    }

    setError("");
    setSelectedImageFile(selectedFile);
    setImagePreview(URL.createObjectURL(selectedFile));

    // Reset the file input so same file can be uploaded again
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleCheckboxChange = (offerId, isSpecial = false) => {
    setBannerData((prevData) => {
      const key = isSpecial ? "specialOfferIds" : "offerIds";
      return {
        ...prevData,
        [key]: prevData[key].includes(offerId)
          ? prevData[key].filter((id) => id !== offerId)
          : [...prevData[key], offerId],
      };
    });
  };

  // Input Change
  const handleOfferChange = (event) => {
    const { name, value } = event.target;

    setOfferData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle Submit
  const handleOfferSubmit = (e) => {
    e.preventDefault();

    if (
      !offerData.discountPercentage ||
      !offerData.startDate ||
      !offerData.endDate
    ) {
      toast.error("All fields are required");
      return;
    }

    if (offerData.startDate < todayDateTime) {
      toast.error("Start date must be in the future");
      return;
    }
    if (offerData.endDate <= offerData.startDate) {
      toast.error("End date must be after the start date");
      return;
    }

    const formattedOfferData = {
      ...offerData,
      startDate: dayjs(offerData.startDate).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: dayjs(offerData.endDate).format("YYYY-MM-DDTHH:mm:ss"),
    };

    dispatch(createSpecialOffer(formattedOfferData));

    // Reset Form
    setOfferData({
      discountPercentage: "",
      startDate: "",
      endDate: "",
    });
    setEditingId(null);
  };

  // Handle Offer Delete
  const handleOfferDelete = (offerId) => {
    dispatch(deleteOffer(offerId));
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!bannerData.category) {
      toast.error("Please select category !");
      return;
    }
    const { brandId, offerIds, specialOfferIds } = bannerData;

    const isVendorPresent = vendorId !== "";
    const isBrandPresent = brandId !== "";
    const isOffersPresent = offerIds?.length > 0;
    const isSpecialOffersPresent = specialOfferIds?.length > 0;

    if (!isVendorPresent && !isBrandPresent && !isOffersPresent && !isSpecialOffersPresent) {
      toast.error("At least one selection is required!");
      return;
    }

    const formData = new FormData();
    if (selectedImageFile) {
      formData.append("imageFile", selectedImageFile); // ✅ match backend key
    }
    const formattedata = {
      ...bannerData,
      vendorId: vendorId,
    };


    if (editingId) {
      dispatch(updateBanner(editingId, formattedata, formData));
    } else {
      if (!selectedImageFile) {
        toast.error("Please upload an image");
        return;
      }
      dispatch(createBanner(formattedata, formData));
    }

    handleCancle();
  };

  const handleBannerUpdate = (item) => {
    setIsFestival(item.specialOffers.length > 0 ? true : false || item.bannerType === "FESTIVAL_SPECIFIC")
    setBannerData({
      brandId: item.brand?.id || "",
      vendorId: item.vendor?.id || "",
      category: item.category,
      offerIds: item.associatedLinks?.map((link) => link.id) || [],
      specialOfferIds: item.specialOffers?.map((link) => link.id) || []
    });
    setSelectedImageFile(null);
    setUploadedImage(item.imageUrl);
    setEditingId(item.id);
    setOpenAddOfferModal(true);
    setSelectedBrandId(item.brand?.id);
    setVendorId(item.vendor?.id);
  };

  const handleDelete = () => {
    dispatch(deleteBanner(deleteId));
    setOpenConfirm(false);
    setDeleteId(null);
  };


  const handleCancle = () => {
    setBannerData({ brandId: "", vendorId: "", category: "", offerIds: [], specialOfferIds: [] });
    setVendorId(null);
    setSelectedBrandId(null);
    setSelectedImageFile(null);
    setImagePreview(null);
    setUploadedImage(null);
    setEditingId(null);
    setOpenAddOfferModal(false);
    setIsFestival(false)
    setError("")
  }

  const writeAction = PermissionService.has({ category: "Admin", page: "Banners", type: "WRITE" });

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    {
      field: "discountPercentage",
      headerName: "Discount",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "startDate",
      headerName: "Start Date & Time",
      flex: 1.5,
      minWidth: 180,
      renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY HH:mm") : "----",
    },
    {
      field: "endDate",
      headerName: "End Date & Time",
      flex: 1.5,
      minWidth: 180,
      renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY HH:mm") : "----",
    },
    ...(writeAction ? [
      {
        field: "actions",
        headerName: "Delete",
        flex: 1,
        minWidth: 120,
        sortable: false,
        renderCell: (params) => (
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleOfferDelete(params.row.id)}
          >
            Delete
          </Button>
        ),
      },
    ] : []),
  ];

  // Define columns
  const bannerColumns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    { field: "vendor", headerName: "Vendor", flex: 1 },
    { field: "brand", headerName: "Brand", flex: 1 },
    { field: "category", headerName: "Category", flex: 1 },
    {
      field: "bannerType",
      headerName: "Banner Type",
      flex: 1,
      renderCell: (params) =>
        params.value === "FESTIVAL_SPECIFIC"
          ? "Festival Banner"
          : params.value === "PLATFORM_SPECIFIC"
            ? "Sale Banner"
            : "Product Banner",
    },

    { field: "links", headerName: "Links", flex: 1.5, renderCell: (params) => (params.row.bannerType === "FESTIVAL_SPECIFIC" ? params.row.festivalOffers : params.value) },
    {
      field: "image",
      headerName: "Image",
      flex: 1.5,
      renderCell: (params) => (
        <img
          onClick={() => { setImageOpen(true); setImageUrl(params?.value) }} className="cursor-pointer"
          src={params.value}
          alt="Banner"
          style={{ width: 100, height: "auto", borderRadius: 4 }}
        />
      ),
    },
    ...(writeAction ? [
      {
        field: "actions",
        headerName: "Action",
        width: 120,
        sortable: false,
        renderCell: (params) => (
          <Box display="flex" gap={0} sx={{ p: 0, m: 0, minHeight: 0 }}>
            <Tooltip title="Edit">
              <IconButton
                size="small"
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => handleBannerUpdate(params.row.banner)}
              >
                <Edit fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="error"
                size="small"
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => {
                  setDeleteId(params.row.id);
                  setOpenConfirm(true);
                }}
              >
                <Delete fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
          </Box>
        )
      }
    ] : []),
  ];


  const bannerRows =
    banners.banners?.response?.map((item) => ({
      id: item.id,
      brand: item.brand?.name || "----",
      vendor: item.vendor?.name || "----",
      category: item.category,
      bannerType: item.bannerType,
      links: item.associatedLinks?.length
        ? item.associatedLinks
          .map((link) => link.discountPercentage)
          .join(", ")
        : "----",
      festivalOffers: item.specialOffers?.length
        ? item.specialOffers
          .map((offer) => offer.discountPercentage)
          .join(", ")
        : "----",
      image: item.imageUrl,
      banner: item
    })) || [];

  const [searchText, setSearchText] = useState("");

  const filteredBannerRows = bannerRows.filter(row => {
    const query = searchText.toLowerCase();
    return (
      row.vendor.toLowerCase().includes(query) ||
      row.brand.toLowerCase().includes(query) ||
      row.category.toLowerCase().includes(query) ||
      row.bannerType.toLowerCase().includes(query) ||
      row.links.toLowerCase().includes(query)
    );
  });

    const getExportData = () => getSelectedExportRows(filteredBannerRows, selectedRowIds);

  const handleExportCSV = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const csvContent = exportRows.map((row, index) => [index + 1,
    row.vendor, row.brand, row.category, row.bannerType, row.links
    ].join(',')).join('\n');
    const headers = ['S.No.', 'Vendor', 'Brand', 'Category', 'Banner Type', 'Links'].join(',');
    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'banners.csv';
    link.click();
  };
  const handleExportPDF = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("Banner List", 14, 15);
    const tableColumn = ['S.No.', 'Vendor', 'Brand', 'Category', 'Banner Type', 'Links'];
    const tableRows = exportRows.map((row, index) => [index + 1, row.vendor, row.brand, row.category, row.bannerType, row.links]);
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      theme: 'striped',
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      styles: { fontSize: 8, cellPadding: 1, overflow: 'linebreak' },
    });
    doc.save('banners.pdf');
  };
  const handlePrint = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const printWindow = window.open('', '_blank');
    const headers = ['S.No.', 'Vendor', 'Brand', 'Category', 'Banner Type', 'Links'];
    const tableContent = exportRows.map((row, index) => [index + 1, row.vendor, row.brand, row.category, row.bannerType, row.links]);
    const html = `
      <html>
        <head>
          <title>Banner List</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th {background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact; }
            tr:nth-child(even) { background-color: #f5f5f5; }
          </style>
        </head>
        <body>
          <h2>Banner List</h2>
          <table>
            <thead>
              <tr>
                ${headers.map(header => `<th>${header}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${tableContent.map(row => `
                <tr>
                  ${row.map(cell => `<td>${cell}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.print();
  };


  return (
    <div className="relative">
      <Card className="p-3" sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardHeader
          title={
            <Typography variant="h6" className="text-gray-700">
              BANNERS
            </Typography>
          }
          action={writeAction && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton
                sx={{
                  background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                  color: "#fff",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                  transition: "all 0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                    transform: "scale(1.02)",
                  },
                  cursor: "pointer",
                  p: 1,
                  borderRadius: '50%',
                }}
                onClick={() => {
                  setOpenAddOfferModal(true);
                  setEditingId(null);
                }}
              >
                <AddIcon />
              </IconButton>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: "#449AEF", fontSize: "1.2rem", letterSpacing: 0.2 }}
              >
                Add Banner
              </Typography>
            </Box>
          )}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
            <Button
              variant="contained"
              startIcon={<FileDownload />}
              onClick={handleExportCSV}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Export CSV
            </Button>
            <Button
              variant="contained"
              startIcon={<PictureAsPdf />}
              onClick={handleExportPDF}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Export PDF
            </Button>
            <Button
              variant="contained"
              startIcon={<Print />}
              onClick={handlePrint}
              sx={{
                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.85rem',
                borderRadius: '6px',
                px: 2,
                py: 0.8,
                transition: 'all 0.2s',
                '&:hover': {
                  background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                  boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                  transform: 'scale(1.02)',
                },
                cursor: 'pointer',
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Print
            </Button>
          </Box>
          <Box>
            <TextField
              label="Search Banners"
              variant="outlined"
              size="small"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              sx={{ width: { xs: '100%', sm: '300px' } }}
            />
          </Box>
        </Box>
        <Box sx={{ height: `calc(100vh - 250px)`, width: "100%" }}>
          <DataGrid
            rows={filteredBannerRows}
            columns={bannerColumns}
            getRowId={(row) => row.id}
            pagination
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10, 25, 50, 75, 100]}
            checkboxSelection
            onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)}
            rowSelectionModel={selectedRowIds}
            disableSelectionOnClick
            density="compact"
            experimentalFeatures={{ virtualization: true }}
            loading={banners.loading}
            autoHeight={true}
            sx={{
              borderRadius: 2,
              fontSize: "0.8rem",
              "& .MuiDataGrid-cell": {
                fontSize: "0.8rem",
                border: "1px solid rgb(204, 201, 201)",
                minHeight: "36px !important",
                height: "36px !important",
                lineHeight: "1.2",
                paddingTop: "4px",
                paddingBottom: "4px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#449AEF",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "0.8rem",
                padding: "8px",
                border: "1px solid rgb(204, 201, 201)",
                minHeight: "36px !important",
                height: "36px !important",
                lineHeight: "1.2",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "0.8rem",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row": {
                maxHeight: "36px !important",
                minHeight: "36px !important",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#f5f5f5",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#ffffff",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          />
        </Box>
      </Card>

      {/* Replace the form rendering with a Dialog: */}
      <Dialog
        open={openAddOfferModal}
        onClose={handleCancle}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '1.25rem',
            fontWeight: 'bold',
            mt: 1,
            mb: 0.5,
            pb: 1,
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          }}
        >
          {editingId ? "UPDATE " : "ADD NEW "} BANNER
          <IconButton onClick={handleCancle} size="small" sx={{ ml: 2 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 2, py: 1 }}>
          <Card className="mb-2 mt-2" sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ p: 1 }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="vendor-label">Select Vendor</InputLabel>
                      <Select
                        labelId="vendor-label"
                        label="Select Vendor"
                        value={vendorId}
                        onChange={(e) => setVendorId(e.target.value)}
                      >
                        <MenuItem value={""}>
                          Select Vendor...
                        </MenuItem>
                        {adminVendor?.vendors?.response?.map(
                          (vendor) =>
                            vendor && (
                              <MenuItem key={vendor.id} value={vendor.id}>
                                {vendor.name}
                              </MenuItem>
                            )
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="brand-label">Select Brand</InputLabel>
                      <Select
                        labelId="brand-label"
                        value={selectedBrandId}
                        name="brandId"
                        label="Select Brand"
                        onChange={fieldChanged}
                      >
                        <MenuItem value={""} >
                          Select Brand...
                        </MenuItem>
                        {[
                          ...new Map(
                            adminProduct.products?.response
                              ?.filter((p) => !vendorId || vendorId === 0 || p.vendor.id === vendorId)
                              .map((p) => [p.brand.id, p.brand])
                          ).values(),
                        ].map((brand) => (
                          <MenuItem key={brand.id} value={brand.id}>
                            {brand.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Select Category</InputLabel>
                      <Select
                        name="category"
                        label="Select Category"
                        value={bannerData.category}
                        onChange={handleChange}
                      >
                        <MenuItem value={0} disabled>
                          Select Banner Category...
                        </MenuItem>
                        <MenuItem value="MAIN">Main Banner</MenuItem>
                        <MenuItem value="SIDE">Side Banner</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    {/* Wrap everything inside a vertical Box */}
                    <Box>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{ py: 1.8 }}
                        startIcon={<UploadFile />}
                      >
                        Upload Image
                        <input
                          type="file"
                          hidden
                          ref={fileInputRef}
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                      </Button>

                      {/* Error shown below the button */}
                      {error && (
                        <Typography color="error" variant="caption" mt={1}>
                          {error}
                        </Typography>
                      )}
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isFestival}
                            onChange={(e) => setIsFestival(e.target.checked)}
                          />
                        }
                        label="Festival Banner"
                      />

                      {isFestival && (
                        <AddCircle
                          fontSize="small"
                          color="primary"
                          sx={{ cursor: "pointer" }}
                          onClick={handleOpenModal}
                        />
                      )}
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="h6">
                        Select Offers
                      </Typography>
                    </Box>
                  </Grid>

                  {[
                    ...new Map(
                      (
                        isFestival
                          ? adminOffers.specialOffers?.response
                          : adminOffers.offers?.response || []
                      )?.map((offer) => [offer.discountPercentage, offer])
                    ).values()
                  ].map((offer) => (
                    <Grid item xs={6} sm={4} md={2} key={offer.id}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={offer.id}
                              checked={isFestival ? bannerData.specialOfferIds.includes(offer.id) : bannerData.offerIds.includes(offer.id)}
                              onChange={() => handleCheckboxChange(offer.id, isFestival ? true : false)}
                            />
                          }
                          label={`${offer.discountPercentage}%`}
                        />
                      </FormGroup>
                    </Grid>
                  ))}

                  {/* Uploaded Image */}
                  {uploadedImage && (
                    <Grid item xs={12} sm={4}>
                      <Typography variant="subtitle1">Current Image:</Typography>
                      <Box
                        component="img"
                        src={uploadedImage}
                        alt="Uploaded"
                        sx={{ width: "100%", maxWidth: 200, borderRadius: 2, mt: 1 }}
                      />
                    </Grid>
                  )}

                  {/* Preview */}
                  {imagePreview && (
                    <Grid item xs={12} sm={4}>
                      <Typography variant="subtitle1">Image Preview:</Typography>
                      <Box
                        component="img"
                        src={imagePreview}
                        alt="Preview"
                        sx={{ width: "100%", maxWidth: 200, borderRadius: 2, mt: 1 }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", gap: 2, }}>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                          boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                          transform: "scale(1.02)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      {editingId ? "Update " : "Add "} Banner
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleCancle}
                      sx={{
                        color: "#449AEF",
                        borderColor: "#449AEF",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          backgroundColor: "#449AEF",
                          color: "#fff",
                          borderColor: "#449AEF",
                          boxShadow: "0 2px 8px rgba(239,68,68,0.1)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>

                </Grid>
              </form>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>


      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: { backgroundColor: "#f9fafb", borderRadius: 2 },
        }}
      >
        {/* Header with Close Icon */}
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
          <Typography variant="h6" fontWeight="600">
            MANAGE FESTIVAL OFFER
          </Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: { xs: 1, sm: 2 } }}>
          {/* FORM CARD */}
          <Card sx={{ p: { xs: 1, sm: 2 }, borderRadius: 2, boxShadow: 1 }}>
            <CardHeader
              title={
                <Typography variant="h6" align="center" className="text-gray-700">
                  ADD FESTIVAL OFFER
                </Typography>
              }
            />
            <form onSubmit={handleOfferSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Discount Percentage"
                    name="discountPercentage"
                    type="number"
                    size="small"
                    value={offerData.discountPercentage}
                    onChange={handleOfferChange}
                    inputProps={{ min: 1 }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Start Date & Time"
                    name="startDate"
                    type="datetime-local"
                    value={offerData.startDate}
                    onChange={handleOfferChange}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: todayDateTime }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="End Date & Time"
                    name="endDate"
                    type="datetime-local"
                    value={offerData.endDate}
                    onChange={handleOfferChange}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: offerData.startDate }}
                  />
                </Grid>
              </Grid>

              <DialogActions sx={{ mt: 2, justifyContent: "center" }}>
                <Button onClick={handleCloseModal} variant="outlined">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "#449AEF",
                    color: "#fff",
                    ml: 2,
                    "&:hover": { backgroundColor: "#dc2626" },
                  }}
                >
                  Add Offer
                </Button>
              </DialogActions>
            </form>
          </Card>

          {/* TABLE CARD */}
          <Card sx={{ mt: 2, p: { xs: 1, sm: 2 }, borderRadius: 2, boxShadow: 1 }}>
            <CardHeader
              title={
                <Typography variant="h6" className="text-gray-700">
                  FESTIVAL OFFERS
                </Typography>
              }
            />
            <Box sx={{ height: "100%", width: "100%" }}>
              <DataGrid
                rows={adminOffers?.specialOffers?.response || []}
                columns={columns}
                pagination
                initialState={{
                  pagination: { paginationModel: { pageSize: 5, page: 0 } },
                }}
                pageSizeOptions={[5, 10, 15, 20, 25]}
                getRowId={(row) => row.id}
                disableSelectionOnClick
                density="compact"
                experimentalFeatures={{ virtualization: true }}
                loading={adminOffers.loading}
                autoHeight={true}
                sx={{
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  "& .MuiDataGrid-cell": {
                    fontSize: "0.8rem",
                    border: "1px solid rgb(204, 201, 201)",
                    minHeight: "36px !important",
                    height: "36px !important",
                    lineHeight: "1.2",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#449AEF",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    padding: "8px",
                    border: "1px solid rgb(204, 201, 201)",
                    minHeight: "36px !important",
                    height: "36px !important",
                    lineHeight: "1.2",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontSize: "0.8rem",
                    fontWeight: 600,
                  },
                  "& .MuiDataGrid-row": {
                    maxHeight: "36px !important",
                    minHeight: "36px !important",
                  },
                  "& .MuiDataGrid-row:nth-of-type(odd)": {
                    backgroundColor: "#f5f5f5",
                  },
                  "& .MuiDataGrid-row:nth-of-type(even)": {
                    backgroundColor: "#ffffff",
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
            </Box>
          </Card>
        </DialogContent>
      </Dialog>
      {/* delete dialog box */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Banner?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(deleteId);   // Call your delete function   
            }}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />
    </div>
  );
};

export default AddBanner;
